"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleRounding = void 0;
/**
 * Handles rounding of property score values. The different endpoints use different attribute
 * names for the scores, so this obfuscates that a little.
 * @param score - the property score provided by the API
 * @returns IRoundedScores - the unrounded and rounded scores
 */
exports.handleRounding = (score) => {
    return {
        unrounded_score: score,
        score: Math.round(score)
    };
};
//# sourceMappingURL=helpers.js.map